var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('p',{staticClass:"not-found__title"},[_vm._v("Ошибка 404")]),_c('p',{staticClass:"not-found__text"},[_vm._v(" Упс! Запрошенная вами страница не может быть найдена... ")]),_c('router-link',{staticClass:"button button--primery",attrs:{"to":{ name: 'main' }}},[_vm._v("Вернуться на главную")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }